<template>
  <div id="Func5BuscaMedicamentos">
    <div class="header print-ignore">
      <FuncionalidadeHeader
        :titulo="funcParams.dashboard.nome"
      />
    </div>
    <div class="medicamento-tela">
      <!-- Filtro -->
      <el-row>
        <el-col :span="8" class="filtro print-ignore">
          <div>
            <el-row style="margin: 20px 0 10px 0">
              <el-col :span="24">
                <h3 class="func-5-title-header">
                  Nova busca
                </h3>
              </el-col>
            </el-row>
            <el-form label-position="">
              <el-form-item
                :error="errors.first('id_plano')" :label="funcParams.textos.tituloTelaSelecaoPlano"
                :required="true"
              >
                <el-select v-model="planoSelecionado" clearable placeholder="Selecione">

                  <el-option-group
                    v-for="groupo in planos"
                    :key="groupo.titulo"
                    :label="groupo.titulo"
                  >
                    <el-option
                      v-for="(plano, index) in groupo.planos"
                      :key="index"
                      :label="plano.titulo"
                      :value="plano.idPlano"
                    />
                  </el-option-group>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Princípio Ativo"
              >
                <el-input
                  v-model="principioAtivo"
                  placeholder="Digite o princípio ativo"
                />
              </el-form-item>

              <el-button
                :style="{
                background: estilo.aplicacao.corPrimariaAplicacao,
                color: 'white',
                height: '44px',
                width: '100%'
                }"
                @click="executaBusca"
              >
                {{ funcParams.textos.textoBotaoBuscaMedicamento }}
              </el-button>
            </el-form>
          </div>
        </el-col>

        <!-- Conteúdo -->
        <el-col :span="16" class="conteudo">
          <div>
            <!-- Estado 1: Bem-vindo -->
            <div v-if="estado === 1" class="bem-vindo">
              <div
                :style="{ background: estilo.aplicacao.corPrimariaAplicacao + '14' }"
                class="icone_medicamentos"
              >
                <svg-icone
                  :cor="estilo.aplicacao.corPrimariaAplicacao"
                  height="68px"
                  icone="Dash_medicamentos"
                  width="68px"
                />
              </div>
              <h3>Bem-vindo à busca de medicamentos</h3>
              <p>Use os campos ao lado para realizar a busca.</p>
            </div>

            <!-- Estado 2: Lista de medicamentos -->
            <div v-if="estado === 2" class="lista-medicamentos">
              <div class="conteudo-header print-ignore">
                <h3>Resultados da busca ({{ medicamentos.length }})</h3>
                <el-button class="print-ignore" type="text" @click="printLista">
                  <div :style="{color: estilo.aplicacao.corPrimariaAplicacao}" style="display:flex; align-items: center; font-size: 14px;">
                    <svg-icone
                      :cor="estilo.aplicacao.corPrimariaAplicacao"
                      icone="Dash_print"
                      :height="18"
                    />
                    imprimir
                  </div>
                </el-button>
              </div>
              <el-row :gutter="20">
                <el-col v-for="(medicamento, index) in medicamentos" :key="index" :span="24">
                  <el-card
                    :style="{ background: estilo.aplicacao.corPrimariaAplicacao + '14' }"
                    shadow="hover"
                  >
                    <div
                      style="display: flex; justify-content: space-between; align-items: center;"
                      @click="verDetalhes(medicamento)"
                    >
                      <div style="flex: 1;">
                        <h4>{{ medicamento.nomeMedicamento }}</h4>
                        <p>{{ medicamento.principioAtivo }} - {{ medicamento.descricao }}</p>
                      </div>
                      <div class="print-ignore" :style="{color: estilo.aplicacao.corPrimariaAplicacao, fontSize: '16px', cursor: 'pointer'}">
                        >
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>

            <!-- Estado 3: Detalhes do medicamento -->
            <div v-if="estado === 3" class="detalhes">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                <h3>{{ detalheMedicamento.nomeMedicamento }}</h3>
                <el-button type="text" @click="voltarParaLista">fechar</el-button>
              </div>
              <el-card shadow="never">
                <span>Princípio Ativo:</span> <br>
                <p>{{ detalheMedicamento.principioAtivo }}</p>
                <span>Descrição:</span> <br>
                <p>{{ detalheMedicamento.descricao }}</p>
              </el-card>
              <el-card shadow="never">
                <div v-for="(item, index) in detalheMedicamento.informacoes" :key="index">
                  <span>{{ item.chave }}:</span> <br>
                  <p>{{ item.valor }}</p>
                </div>
              </el-card>
            </div>

            <!-- Estado 4: Nenhum medicamento encontrado -->
            <div v-if="estado === 4" class="nenhum-resultado">
              <div
                :style="{ background: estilo.aplicacao.corPrimariaAplicacao + '14' }"
                class="icone_medicamentos"
              >
                <svg-icone
                  :cor="estilo.aplicacao.corPrimariaAplicacao"
                  height="68px"
                  icone="Dash_medicamentos"
                  width="68px"
                />
              </div>
              <h3>{{ funcParams.textos.tituloVazioListaMedicamentos }}</h3>
              <p>{{ funcParams.textos.textoVazioListaMedicamentos }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader.vue'

export default {
  name: 'Func4RedeCredenciadaListagem',
  components: { FuncionalidadeHeader },
  data () {
    return {
      planos: [],
      medicamentos: [],
      detalheMedicamento: null,
      estado: 1, // Estados: 1 = Bem-vindo, 2 = Lista, 3 = Detalhes, 4 = Nenhum
      principioAtivo: '',
      planoSelecionado: null
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'funcParams']),
    ...mapGetters('Login', ['chaveUnica'])
  },
  methods: {
    async init () {
      await this.buscaPlanos()
    },
    async buscaPlanos () {
      this.planos = []

      const result = await this.apiFuncionalidade.listaPlanos({
        payload: { chaveUnica: this.chaveUnica },
        handlerErrorIgnore: [404]
      })

      if (!result.status) return null

      this.planos = result.data.vinculoPlano
    },
    async executaBusca () {
      if (!this.planoSelecionado) {
        return
      }

      const payload = {
        idPlano: this.planoSelecionado
      }
      if (this.principioAtivo) {
        payload.principioAtivo = this.principioAtivo
      }
      const result = await this.apiFuncionalidade.listaMedicamentos({
        payload,
        handlerErrorIgnore: [404]
      })

      if (!result.status) return null

      this.medicamentos = result.data.medicamentos

      this.medicamentos.length ? this.estado = 2 : this.estado = 4
    },
    async verDetalhes (medicamento) {
      if (!medicamento) {
        return null
      }
      const result = await this.apiFuncionalidade.detalheMedicamento({
        payload: {
          chaveUnica: this.chaveUnica,
          idMedicamento: medicamento.idMedicamento
        },
        handlerErrorIgnore: [404]
      })
      if (!result.status) return null

      this.detalheMedicamento = result.data
      this.estado = 3
    },
    voltarParaLista () {
      this.estado = 2 // Volta para a lista
    },
    printLista () {
      window.print()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less">
@media print {
  .print-ignore {
    display: none; /* Esconde todos os elementos */
  }
}
#Func5BuscaMedicamentos {
  .medicamento-tela {
    padding: 0 20px 20px;
  }

  .filtro {
    padding-right: 20px;
    border-right: 1px solid #EEEEEE;

    .func-5-title-header {
      letter-spacing: 0;
      font-weight: 600;
      color: #333333;
      font-size: 24px;
    }
  }

  .conteudo {
    border-left: 1px solid #EEEEEE;
    padding-left: 20px;
    //height: 100vh;
    //padding-top: 80px;
    box-sizing: border-box;

    .conteudo-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }

  .bem-vindo,
  .nenhum-resultado {
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding-top: 80px;

    h3, p {
      width: 60%;
    }
  }

  .icone_medicamentos {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 100px;
    height: 100px;
  }

  .lista-medicamentos, .detalhes {
    padding-top: 20px;
  }

  .lista-medicamentos {
    .el-card {
      cursor: pointer;
      border-radius: 10px;
    }

    p {
      margin: 0;
    }
  }

  .detalhes {
    .el-card {
      background-color: #F6F6F6;
      border-radius: 6px;

      span {
        font: normal normal normal 11px/15px Open Sans;
        letter-spacing: 0;
        color: #333333;
      }

      p {
        font: normal normal normal 14px/19px Open Sans;
        letter-spacing: 0;
        color: #333333;
        margin-top: 2px;
        margin-bottom: 15px;
      }

      p:last-child {
        margin-bottom: 0;
      }

      div {
        margin-bottom: 15px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  }
}

</style>
